import { render, staticRenderFns } from "./paydifyWallet.vue?vue&type=template&id=53281950&scoped=true"
import script from "./paydifyWallet.vue?vue&type=script&lang=js"
export * from "./paydifyWallet.vue?vue&type=script&lang=js"
import style0 from "./paydifyWallet.vue?vue&type=style&index=0&id=53281950&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53281950",
  null
  
)

export default component.exports